<template>
    <ui5-popover
        class="popover-repair-reason-form"
        ref="popover"
        :header-text="headerText">
        <div class="popover-contents">
            <p>
                Geef de reden, het boxnummer en het aantal verpakkingen voor dit
                product op.
            </p>
            <div class="field">
                <ui5-label>Reden</ui5-label>
                <ui5-select class="repairreasonselect">
                    <template v-for="reason in repairReasons">
                        <ui5-option
                            :value="reason.repairreasonId"
                            :key="reason.repairreasonId">
                            {{ reason.description }}
                        </ui5-option>
                    </template>
                </ui5-select>
            </div>
            <div class="field">
                <ui5-label>Boxnr</ui5-label>
                <ui5-input
                    type="Text"
                    name="boxnr"
                    class="boxnr"
                    placeholder="Boxnr" />
            </div>
            <div class="field">
                <ui5-label># colli</ui5-label>
                <ui5-input
                    type="Text"
                    name="colli"
                    class="colli"
                    placeholder="Colli" />
            </div>
            <div class="buttons">
                <ui5-button @click="execute">Bevestigen</ui5-button>
                <ui5-button @click="$refs.popover.close()">
                    Annuleren
                </ui5-button>
            </div>
        </div>
    </ui5-popover>
</template>
<script>
import { isNumber } from '../../helpers/GeneralHelper';
import { showErrorMessage } from '../../dialogs';

export default {
    props: {
        productId: String,
        repairReasons: Array,
        action: Function,
        headerText: String,
    },
    methods: {
        open(openBy) {
            this.$refs.popover.showAt(openBy);
        },
        getFormData() {
            const boxnr = this.$el.querySelector('.boxnr').value;
            const colli = this.$el.querySelector('.colli').value;
            const repairReasonSelector = this.$el.querySelector(
                '.repairreasonselect'
            );
            const repairReasonId =
                repairReasonSelector && repairReasonSelector.selectedOption
                    ? repairReasonSelector.selectedOption.value
                    : '';
            return { boxnr, colli, repairReasonId };
        },
        execute() {
            const { boxnr, colli, repairReasonId } = this.getFormData();

            const valid =
                boxnr != undefined &&
                boxnr != '' &&
                colli != undefined &&
                isNumber(colli);
            if (!valid) {
                return showErrorMessage(
                    'De velden moeten ingevuld zijn en het aantal colli moet een nummer zijn.'
                );
            }
            this.action(this.productId, boxnr, colli, repairReasonId);
            this.$refs.popover.close();
        },
    },
};
</script>
